export enum DmsUserRole {
  BoWithoutCpa = 'BoWithoutCpa',
  BoWithCpa = 'BoWithCpa',
  CpaClientMode = 'CpaClientMode',
  CpaExpertMode = 'CpaExpertMode',
}
